export var FEEDBACK_DIV_ID = 'inapp-feedback-element-id';
export var HARMONY_APP_ID = 2131;
export var HARMONY_APP_NAME = 'Harmony';
//# sourceMappingURL=constants.js.map